// @ts-nocheck

// dynamic imports locations must be static strings as they are analysed by vite during bundling. Otherwise, they will not work.
const momentLocaleImports = {
    de: () => import('moment/dist/locale/de'),
    'en-gb': () => import('moment/dist/locale/en-gb'),
};

export const getMomentLocaleKey = (locale: string) => {
    const countryCode = locale.substring(0, 2);
    if (countryCode === 'en') {
        return 'en-gb';
    }
    return countryCode;
};

export const importMomentLocale = async (locale: string) => {
    if (momentLocaleImports[locale]) {
        await momentLocaleImports[locale]();
    } else {
        throw new Error(`momentLocale ${locale} not supported`);
    }
};
